import { render, staticRenderFns } from "./PasswordFormContainer.vue?vue&type=template&id=65bae02f&"
import script from "./PasswordFormContainer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PasswordFormContainer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports